import React, { useEffect, createContext, useReducer } from 'react';
const zendeskAccountKey = process.env.REACT_APP_ZENDESK_ACCOUNT_KEY;

const initState = {
  isOnline: true,
  message: ''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CONNECTED':
      return { ...state, isOnline: true, message: '' };
    case 'DISCONNECTED':
      return { ...state, isOnline: false, message: "You're offline!" };
    case 'CLEAR_MESSAGE':
      return { ...state, message: '', isOnline: false };
    default:
      return state;
  }
};

export const NetworkContext = createContext({
  ...initState,
  clearMessage: () => {}
});

const NetworkDetector = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState);

  useEffect(() => {
    // setTimeout(() => {
    // console.log(Offline.check(), 'Mode offline 1111', Offline.state);
    // Offline.on('confirmed-down', () => {
    //   console.log('offline');
    // });
    // Offline.on('confirmed-up', (payloads) => {
    //   console.log(payloads, 'online', Offline.state, Offline.check());
    // });
    // }, 5000);
  }, [Offline.state]);

  // useEffect(() => {
  //   zChat.init({
  //     account_key: zendeskAccountKey
  //   });
  //   // setTimeout(() => {
  //     zChat.on('connection_update', function (status) {
  //       console.log(status,"connection !!!!!!")
  //       if (status === 'connected') {
  //         dispatch({
  //           type: 'CONNECTED'
  //         });
  //       } else {
  //         dispatch({
  //           type: 'DISCONNECTED'
  //         });
  //       }
  //     });
  //   // }, 2000);
  // }, [zChat]);

  const clearMessage = () => {
    dispatch({
      type: 'CLEAR_MESSAGE'
    });
    setTimeout(() => {
      if (state.isOnline == false) {
        dispatch({
          type: 'DISCONNECTED'
        });
      }
    }, 5000);
  };
  return (
    <NetworkContext.Provider value={{ ...state, clearMessage }}>
      {children}
    </NetworkContext.Provider>
  );
};

export default NetworkDetector;
